import { useState } from "react";
import TextAreaInput from "../../../components/TextAreaInput";
import BaseSection from "../../BaseSection";
import { Container } from "./styles";
import QuestionTypeSelect from "../../../components/QuestionTypeSelect";
import swal from 'sweetalert';
import QuestionOptionalCheckbox from "../../../components/QuestionOptionalCheckbox";
import { newQuestionPayload, SURVEY_QUESTION_FIELDS } from "../../../../constants";

export default function Question({
  question = {},
  isFirstQuestion = false,
  isLastQuestion = false,
  onChangeQuestion = () => null,
  onDeleteQuestion = () => null,
  onChangeQuestionOrder = () => null,
}) {
  const defaultData = question;

  const [data, setData] = useState(question);
  const [isEditting, setIsEditting] = useState(false);

  const toggleIsEditting = () => {
    setIsEditting((prev) => !prev);
  };

  const handleChangeQuestionValue = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  const handleCancel = () => {
    setData(defaultData);
    toggleIsEditting();
  };

  const handleSave = () => {
    onChangeQuestion(data);
    toggleIsEditting();
  };

  const handleChangeOrder = (newOrder) => {
    onChangeQuestionOrder(newOrder);
  };

  const handleDeleteQuestion = async () => {
    if(question[SURVEY_QUESTION_FIELDS.TITLE] === newQuestionPayload[SURVEY_QUESTION_FIELDS.TITLE] && !question[SURVEY_QUESTION_FIELDS.ID]) {
      onDeleteQuestion(question);
      return;
    }

    const response = await swal({
      title: 'Deseja remover a questão?',
      text: 'Essa ação é irreversível',
      icon: 'warning',
      dangerMode: true,
      buttons: ['Cancelar', 'Remover']
    });

    if(response) {
      onDeleteQuestion(question);
    }
  }

  return (
    <BaseSection
      allowDelete
      allowEdit
      allowChangeOrder
      isFirstItem={isFirstQuestion}
      isLastItem={isLastQuestion}
      isEditting={isEditting}
      onCancelEditting={handleCancel}
      onSubmitEditting={handleSave}
      onToggleIsEditting={toggleIsEditting}
      onChangeOrderDown={() =>
        handleChangeOrder(+question[SURVEY_QUESTION_FIELDS.ORDER] + 1)
      }
      onChangeOrderUp={() =>
        handleChangeOrder(+question[SURVEY_QUESTION_FIELDS.ORDER] - 1)
      }
      onDelete={handleDeleteQuestion}
    >
      <Container>
        <TextAreaInput
          value={data[SURVEY_QUESTION_FIELDS.TITLE]}
          fontSize="1rem"
          fontWeight="500"
          minHeight="2rem"
          readOnly={!isEditting}
          onChange={(e) =>
            handleChangeQuestionValue(
              SURVEY_QUESTION_FIELDS.TITLE,
              e.target.value
            )
          }
        />
        <QuestionTypeSelect
          readOnly={!isEditting}
          selectedType={data[SURVEY_QUESTION_FIELDS.TYPE]}
          linearScale={data[SURVEY_QUESTION_FIELDS.LINEAR_SCALE]}
          select={data[SURVEY_QUESTION_FIELDS.SELECT]}
          onChangeLinearScale={(linearScale) => handleChangeQuestionValue(SURVEY_QUESTION_FIELDS.LINEAR_SCALE, linearScale)}
          onChangeSelect={(select) => handleChangeQuestionValue(SURVEY_QUESTION_FIELDS.SELECT, select)}
          onChangeSelectedType={(type) => handleChangeQuestionValue(SURVEY_QUESTION_FIELDS.TYPE, type)}
        />
        <QuestionOptionalCheckbox
          readOnly={!isEditting}
          checked={!data[SURVEY_QUESTION_FIELDS.OPTIONAL]}
          onChangeChecked={checked => handleChangeQuestionValue([SURVEY_QUESTION_FIELDS.OPTIONAL], checked)}
        />
      </Container>
    </BaseSection>
  );
}
